const setLoggedStaff = (state, loggedStaff) => {
  Object.assign(state, { loggedStaff })
}

const setLoggedStaffListener = (state, listener) => {
  if (state.loggedStaffListener) {
    state.loggedStaffListener()
  }
  state.loggedStaffListener = listener
}

const clearLoggedStaffListener = state => {
  if (state.loggedStaffListener) {
    state.loggedStaffListener()
  }
  state.loggedStaffListener = null
}

export default {
  setLoggedStaff,
  setLoggedStaffListener,
  clearLoggedStaffListener
}
